import { createFileRoute } from '@tanstack/react-router'
import { RoutingSettingsPage } from '@/features/admin/routing-settings'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/routing/')({
  component: RoutingSettingsPage,
  beforeLoad: requireRole(['admin']),
})
